import React, { useEffect } from "react";
import styles from "../../../pages/floraFaunaForm/dashboard/Dashboard.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { withRouter } from "react-router-dom";
import { Button, Loading } from "@onegovbugs/onegov-react-components";
import { applicantItems, qualificationItems, organisationItems, associateItems, focusOfWorkItems, locationItems, additionalInfoItems, projectItems } from "../../../utils/NavigationHelper";
import { renderSection } from "../../../utils/RenderHelper";
import ScrollToTop from "../../../utils/ScrollToTop";
import { RedirectIfCaptchaNotSelected } from "../../../utils/Redirect";
import { saveApplication } from "../../../redux/actions";

const Dashboard = (props) => {
  ScrollToTop();
  RedirectIfCaptchaNotSelected(props);
  const dispatch = useDispatch();
  const application = useSelector((state) => state.application);

  const twoFA = useSelector((state) => state.twoFA);
  const formData = useSelector((state) => state.form);
  const { form, formFetching } = formData;

  const personalDetails = useSelector((state) => state.personalDetails);
  const qualificationDetail = useSelector((state) => state.qualificationDetail);
  const associateDetail = useSelector((state) => state.associateDetail);
  const organisationDetail = useSelector((state) => state.organisationDetail);
  const locationDetail = useSelector((state) => state.locationDetail);
  const focusOfWork = useSelector((state) => state.focusOfWorkDetail);
  const projectDetail = useSelector((state) => state.projectDetail);
  const documentDetail = useSelector((state) => state.documentDetail);

  let personalDetailsStep = personalDetails.step;
  let qualificationDetailStep = qualificationDetail.step;
  let associateStep = associateDetail.step;
  let organisationStep = organisationDetail.step;
  let projectDetailStep = projectDetail.step;
  let locationDetailStep = locationDetail.step;
  let focusOfWorkStep = focusOfWork.step;
  let documentStep = documentDetail.step;
  
  const disableContinue = (!personalDetails.finished || !qualificationDetail.finished || !associateDetail.finished
  || !organisationDetail.finished || !locationDetail.finished || !focusOfWork.finished || !projectDetail.finished || !documentDetail.finished);

  return !formFetching
    ? [<div className={styles.container}>
<div className={"row"}>
          <div className={`col-12 col-md-6`}>
            <div className={styles.backCont}>
              <a
                className={styles.back}
                onClick={() => {
                  props.history.push(`/flora-fauna/class-detail`);
                }}
              >
                &#x3C;&nbsp;Back
              </a>
            </div>
          </div>        
          
          <div className={`col-12 col-md-6 ${styles.navigationApplicationNumberCol}`}>
            <h3 className={styles.navigationApplicationNumber}>{application.applicationNo}</h3>
          </div>
          <div className={`col-12`}>
            <h1 className={`${styles.mainFormTitle} ${styles.underlinedTitle}`}>
              Native Flora and Fauna Research Licence
            </h1>
          </div>
        </div>
    </div>
        ,
        <div className={styles.mainCont}>
          <div className={"row"}>
            <div className={`col-12`}>
              <h2>Sections to complete</h2>
              <p className={styles.mainDescription}>
                Please use sections of the form below to complete your
                application. You can complete your application in any order. You
                can save and exit this form at any time and return to complete
                it later.
              </p>
              {renderSection(
                "Applicant details",
                "Use this section to complete the details of the applicant for this licence",
                `/flora-fauna/applicant-detail`,
                personalDetails.finished,
                personalDetailsStep,
                applicantItems,
                undefined,
                props.history,
                form
              )}
              {renderSection(
                "Qualifications",
                "Use this section to complete the details of the applicant’s relevant qualification(s)",
                `/flora-fauna/qualification`,
                qualificationDetail.finished,
                qualificationDetailStep,
                qualificationItems,
                undefined,
                props.history,
                form
              )}
              {renderSection(
                "Associates",
                "Use this section to complete the details of other people who will be working under the licence",
                `/flora-fauna/associate`,
                associateDetail.finished,
                associateStep,
                associateItems,
                undefined,
                props.history,
                form
              )}
              {renderSection(
                "Organisation Details",
                "Use this section to complete the details of an organisation associated with the licence",
                `/flora-fauna/organisation`,
                organisationDetail.finished,
                organisationStep,
                organisationItems,
                undefined,
                props.history,
                form
              )}
              {renderSection(
                "Project Details",
                "Use this section to include the title, objectives, methodology and equipment of the project to be covered by the licence",
                `/flora-fauna/project-detail`,
                projectDetail.finished,
                projectDetailStep,
                projectItems,
                undefined,
                props.history,
                form
              )}
              {renderSection(
                "Location Data",
                "Use this section to include locations where you intend for the project to be undertaken",
                `/flora-fauna/location`,
                locationDetail.finished,
                locationDetailStep,
                locationItems,
                undefined,
                props.history,
                form
              )}
              {renderSection(
                "Focus of Work",
                "Use this section to include the species, ecological communities or sample types this project will focus on",
                `/flora-fauna/focusofwork`,
                focusOfWork.finished,
                focusOfWorkStep,
                focusOfWorkItems,
                undefined,
                props.history,
                form
              )}
              {renderSection(
                "Additional Information and attachments",
                "Use this section to attach any supporting information required for the selected licence classes",
                `/flora-fauna/upload-document`,
                documentDetail.finished,
                documentStep,
                additionalInfoItems,
                undefined,
                props.history,
                form
              )}
            </div>
            <div className={`col-12`}>
              <Button
                disabled={disableContinue}
                onClick={() => {
                  if (!disableContinue) {
                    props.history.push(`/flora-fauna/review-application`);
                  }
                }}
              >
                Continue
              </Button>
              <Button
                secondary
                onClick={() => {
                  dispatch(
                    saveApplication("", () => {
                      window.location.href = `${process.env.REACT_APP_BAU_URL}`;
                    })
                  );
                }}
              >
                Save & exit application
              </Button>
            </div>
          </div>
        </div>,
      ]
    : [
        <div className={"col-12"}>
          <Loading
            className={styles.loading}
            label={"Loading..."}
            type={"ajax"}
          />
        </div>,
      ];
};

export default withRouter((props) => <Dashboard {...props} />);
